// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1hgex","rootCenter":"LoadMoreObserver_rootCenter__1LlBU","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1tj4A"};